// control-center/src/components/credentials/MintPatDialog.tsx
import { useState } from 'react';

export interface MintPatDialogProps {
  botName: string;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export function MintPatDialog({ botName, onConfirm, onCancel }: MintPatDialogProps) {
  const [pending, setPending] = useState(false);

  const handleConfirm = async () => {
    setPending(true);
    try {
      await onConfirm();
    } finally {
      setPending(false);
    }
  };

  return (
    <div role="dialog" aria-modal="true" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
      <div style={{ background: '#1e293b', color: '#e2e8f0', borderRadius: 8, padding: '1.5rem', maxWidth: 400, width: '100%' }}>
        <h3>Mint new PAT for {botName}?</h3>
        <p style={{ color: '#94a3b8', fontSize: '0.875rem' }}>
          This will generate a new token and store it in Vault. Any existing token will be marked as rotated.
        </p>
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
          <button onClick={onCancel} disabled={pending} style={{ background: '#374151', color: '#d1d5db', border: 'none', borderRadius: 4, padding: '0.4rem 1rem', cursor: 'pointer' }}>
            Cancel
          </button>
          <button onClick={handleConfirm} disabled={pending} style={{ background: pending ? '#3b0764' : '#7c3aed', color: '#fff', border: 'none', borderRadius: 4, padding: '0.4rem 1rem', cursor: pending ? 'wait' : 'pointer' }}>
            {pending ? 'Minting...' : 'Mint Token'}
          </button>
        </div>
      </div>
    </div>
  );
}
